/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BaseGoodsForPackVo1
 */
export interface BaseGoodsForPackVo1 {
    /**
     * 商品id
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    id?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    code?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    imgUrl?: string;
    /**
     * 商品构成
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    constructQuantity?: number;
    /**
     * 商品名称
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    name?: string;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    marketProNm?: string;
    /**
     * 当前基础商品记录的数量；快递件商品为实际拆分后的独立数量
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    quantity?: number;
    /**
     * 已包装数量
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    packagedQuantity?: number;
    /**
     * 快递单号
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    trackingNumber?: string;
    /**
     * 商品颜色
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    color?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    size?: string;
    /**
     * 商品重量 kg
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    weight?: number;
    /**
     * 商品长度 cm
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    length?: number;
    /**
     * 商品宽度 cm
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    width?: number;
    /**
     * 商品高度 cm
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    height?: number;
    /**
     * 商品 CBM
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    cbm?: number;
    /**
     * 是否为火箭订单拆出的快递件商品：0 否，1 是
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    simple?: number;
    /**
     * 原产地标作业方式，存客户下单编码或手填原文
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    originJob?: string;
    /**
     * 原产地标作业方式展示名，按当前语言翻译枚举，手填原文原样返回
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    originJobName?: string;
    /**
     * SKU id
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    skuId?: number;
    /**
     * SKU 编码
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    skuCode?: string;
    /**
     * 原产地
     * @type {string}
     * @memberof BaseGoodsForPackVo1
     */
    origin?: string;
    /**
     * 是否打印原产地标 0 不打印，1 打印
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    originPrint?: number;
    /**
     * 是否可以原包装出库：0 否，1 是
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    originPackageOutbound?: number;
    /**
     * 商品来源，见 GoodsSourceTypeEnum
     * @type {number}
     * @memberof BaseGoodsForPackVo1
     */
    sourceType?: number;
}

/**
 * Check if a given object implements the BaseGoodsForPackVo1 interface.
 */
export function instanceOfBaseGoodsForPackVo1(value: object): value is BaseGoodsForPackVo1 {
    return true;
}

export function BaseGoodsForPackVo1FromJSON(json: any): BaseGoodsForPackVo1 {
    return BaseGoodsForPackVo1FromJSONTyped(json, false);
}

export function BaseGoodsForPackVo1FromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseGoodsForPackVo1 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'constructQuantity': json['constructQuantity'] == null ? undefined : json['constructQuantity'],
        'name': json['name'] == null ? undefined : json['name'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'packagedQuantity': json['packagedQuantity'] == null ? undefined : json['packagedQuantity'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'originJob': json['originJob'] == null ? undefined : json['originJob'],
        'originJobName': json['originJobName'] == null ? undefined : json['originJobName'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'originPrint': json['originPrint'] == null ? undefined : json['originPrint'],
        'originPackageOutbound': json['originPackageOutbound'] == null ? undefined : json['originPackageOutbound'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
    };
}

export function BaseGoodsForPackVo1ToJSON(json: any): BaseGoodsForPackVo1 {
    return BaseGoodsForPackVo1ToJSONTyped(json, false);
}

export function BaseGoodsForPackVo1ToJSONTyped(value?: BaseGoodsForPackVo1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'imgUrl': value['imgUrl'],
        'constructQuantity': value['constructQuantity'],
        'name': value['name'],
        'marketProNm': value['marketProNm'],
        'quantity': value['quantity'],
        'packagedQuantity': value['packagedQuantity'],
        'trackingNumber': value['trackingNumber'],
        'color': value['color'],
        'size': value['size'],
        'weight': value['weight'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'cbm': value['cbm'],
        'simple': value['simple'],
        'originJob': value['originJob'],
        'originJobName': value['originJobName'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'origin': value['origin'],
        'originPrint': value['originPrint'],
        'originPackageOutbound': value['originPackageOutbound'],
        'sourceType': value['sourceType'],
    };
}

